var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22672 6.07422C2.0819 6.35103 2 6.66596 2 7.00002V17C2 18.1046 2.89543 19 4 19H9.40599L9.79576 18.0534C9.9556 17.6652 10.1907 17.3125 10.4876 17.0157L18.3179 9.18534C19.2317 8.27158 20.7132 8.27158 21.627 9.18534L22 9.55838V7.00002C22 6.66596 21.9181 6.35103 21.7733 6.07422L13.577 11.8116C12.6301 12.4744 11.3699 12.4744 10.423 11.8116L2.22672 6.07422Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5731 5.08333C20.3916 5.02912 20.1992 5 20 5H4C3.80082 5 3.60844 5.02912 3.42688 5.08333L11.2832 10.5827C11.7136 10.884 12.2864 10.884 12.7168 10.5827L20.5731 5.08333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 19L22 14.4967V17C22 18.1046 21.1046 19 20 19H17.4967Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5663 10.246C20.2383 9.918 19.7066 9.918 19.3786 10.246L17.8426 11.782L20.218 14.1574L21.754 12.6214C22.082 12.2934 22.082 11.7617 21.754 11.4337L20.5663 10.246Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1574 15.2181L16.782 12.8427L11.5482 18.0765C11.3914 18.2333 11.2672 18.4196 11.1828 18.6246L10.0316 21.4203C9.96712 21.577 10.0031 21.7572 10.123 21.8771C10.2429 21.997 10.4231 22.033 10.5798 21.9685L13.3755 20.8173C13.5805 20.7329 13.7668 20.6087 13.9236 20.4519L19.1574 15.2181Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.3aa01b8701d109ba9383d52258d7d2c0.svg";
export { ForwardRef as ReactComponent };